<template>
  <a id="claim-link" :href="CLAIM_PROD_URL" class="wrapper">
    <div class="background">
      <div class="overlay">
        <div class="overlay__title">{{ $t('banners.lsdBanner.title') }}</div>
        <div class="overlay__description">
          {{ $t('banners.lsdBanner.description') }}
        </div>
      </div>
      <div class="left-coin" />
      <div class="right-coin" />
      <div class="right-title">AIRDROP</div>
    </div>
  </a>
</template>
<script lang="ts" setup>
import { EMixpanelEventNames, EMixpanelProvideKeys } from '@/types/enums';
import { inject, onMounted } from 'vue';
import { CLAIM_PROD_URL } from '@/constants';
import { TrackLinks } from '@/types';

const trackLinks = inject(EMixpanelProvideKeys.TrackLinks) as TrackLinks;

onMounted(() => {
  trackLinks('#claim-link', EMixpanelEventNames.BannerGoAirdrop);
});
</script>
<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 84px;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;
  text-decoration: none;
}
.background {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 84px;
  background: url('@/assets/banners/airdrop-banner-bg.png') no-repeat center
    center / cover transparent;
}
.overlay {
  position: absolute;
  top: 17px;
  left: 104px;
  font-family: Work Sans, serif;
  font-size: 21px;
  font-weight: 700;
  line-height: 24px;
  color: #ffffff;
  z-index: 2;
  @media (max-width: 421px) {
    left: 84px;
    &__title,
    &__description {
      font-size: 16px;
    }
  }
}
.left-coin {
  position: absolute;
  bottom: -26px;
  left: -10px;
  width: 114px;
  height: 114px;
  background: url('@/assets/banners/airdrop-banner-left-coin.png') no-repeat
    center center / cover transparent;
  @media (max-width: 421px) {
    width: 90px;
    height: 90px;
    left: -8px;
    bottom: -8px;
    top: unset;
  }
}
.right-coin {
  position: absolute;
  top: -17px;
  right: -23px;
  width: 153px;
  height: 128px;
  background: url('@/assets/banners/airdrop-banner-right-coin.png') no-repeat
    center center/cover transparent;
  z-index: 1;
  @media (max-width: 421px) {
    display: none;
  }
}
.right-title {
  position: absolute;
  top: 10px;
  right: -34px;
  transform: rotate(43deg);
  transform-origin: 50% 50%;
  white-space: nowrap;
  font-family: Work Sans, serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 24px;
  color: #411f88;
  background-color: #ffffff;
  width: 120px;
  height: 28px;
  display: flex;
  align-items: end;
  justify-content: center;
  z-index: 2;
  @media (max-width: 421px) {
    right: -30px;
  }
}
</style>
